import { config } from 'src/config'
import { getLanguageFromLocale } from 'src/functions/i18n/localeFns'

import { CategoryIndex, getStaticProps } from './[category]'

import type { GetStaticPaths } from 'next'
import type { Locale } from 'src/enum/Locale'

const getStaticPaths: GetStaticPaths = async () => {
  const paths: string[] = []

  config.locales.forEach((locale) => {
    const language = getLanguageFromLocale(locale as Locale)

    paths.push(`/${language}/a`)
  })

  return {
    paths,
    fallback: false,
  }
}

export { getStaticProps, getStaticPaths }

export default CategoryIndex
